import { MetadataConstants, MetadataSelectors } from 'invision-core';
import { SelectedShippingAddressFromDropDownSelector, UpdatedShippingAddressSelector } from '../../../../../reducers/selectors/offering.order.selectors';
import CustomerCareLocaleKeys from '../../../../../locales/keys';
import { setSelectedShippingAddress, setUpdatedShippingAddress } from '../../../../../reducers/actions/offering.order.actions';
import cloneDeep from 'lodash/cloneDeep';
import { stateRequiredHelper } from '../../../../customer/addresses/address.helper';
import { addressStateRegionProvinceValueOptionsForCountry } from '../../../../../reducers/helpers/customer.selectors.helpers';
import { setAddressData } from '../../../../../reducers/actions/customer.addresses.actions';
function ChangeShippingAddressPopupController($ngRedux) {
  var _this = this;
  this.$onInit = function () {
    var mapStateToTarget = function mapStateToTarget(store) {
      return {
        addressCountriesAll: MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.AddressCountry, store),
        addressCountriesLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.AddressCountry, store),
        addressStatesAll: MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.AddressStateProvinceRegion, store),
        addressStatesLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.AddressStateProvinceRegion, store),
        addressRequirements: MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.AddressRequirements, store),
        addressRequirementsLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.AddressRequirements, store),
        selectedShippingAddress: SelectedShippingAddressFromDropDownSelector(store),
        updatedShippingAddress: UpdatedShippingAddressSelector(store)
      };
    };
    var controllerActions = {
      setSelectedShippingAddress: setSelectedShippingAddress,
      setUpdatedShippingAddress: setUpdatedShippingAddress,
      setAddressData: setAddressData
    };
    _this.disconnectRedux = $ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
      _this.state = state;
      _this.actions = actions;
    });
    if (!_this.state.addressCountriesLoaded) {
      _this.actions.fetchCodeType(MetadataConstants.codes.AddressCountry);
    }
    if (!_this.state.addressStatesLoaded) {
      _this.actions.fetchCodeType(MetadataConstants.codes.AddressStateProvinceRegion);
    }
    if (!_this.state.addressRequirementsLoaded) {
      _this.actions.fetchCodeType(MetadataConstants.codes.AddressRequirements);
    }
    _this.addressFormModel = {};
    _this.editShippingAddress = {
      Id: 0,
      Country: null,
      ShipToName: null,
      LineOne: null,
      LineTwo: null,
      State: null,
      City: null,
      PostalCode: null
    };
    _this.customerCareKeys = CustomerCareLocaleKeys;
    _this.onCloseModal = _this.onCloseModal.bind(_this);
    _this.handleChangeDropDownAddress = _this.handleChangeDropDownAddress.bind(_this);
    _this.onAddressFormChanged = _this.onAddressFormChanged.bind(_this);
    _this.onSubmitChangeShippingAddressModal = _this.onSubmitChangeShippingAddressModal.bind(_this);
    _this.showErrorSummary = false;
    _this.editShippingAddress = cloneDeep(_this.state.updatedShippingAddress);
    _this.updateAddressFormModel();
  };
  this.setAddressData = function () {
    var payload = {};
    if (_this.editShippingAddress.Country) {
      payload.Country = _this.editShippingAddress.Country;
    }
    _this.actions.setAddressData(payload);
  };
  this.updateStateField = function () {
    // this.actions.setAddressData(this.editPaymentInstrument.BillingAddress);
    _this.stateRequired = stateRequiredHelper(_this.state.addressRequirements, _this.addressStatesOptions);

    // if Country has states, reset State if it's not one of them
    if (_this.addressStatesOptions && !_this.addressStatesOptions.find(function (stateOption) {
      return stateOption.value === _this.editShippingAddress.State;
    })) {
      _this.editShippingAddress.State = null;
      _this.addressFormModel.stateRegionProvince = _this.editShippingAddress.State;
    }
  };
  this.handleChangeFormCountry = function () {
    _this.setAddressData();
    _this.updateStateField();
  };
  this.onAddressFormChanged = function (addressFormModel) {
    _this.addressFormModel.addressLine1 = addressFormModel.addressLine1;
    _this.addressFormModel.addressLine2 = addressFormModel.addressLine2;
    _this.addressFormModel.city = addressFormModel.city;
    _this.addressFormModel.country = addressFormModel.country;
    _this.addressFormModel.stateRegionProvince = addressFormModel.stateRegionProvince;
    _this.addressFormModel.postalCode = addressFormModel.postalCode ? addressFormModel.postalCode : null;
    _this.addressFormModel.shipToName = addressFormModel.shipToName;
    _this.editShippingAddress = {};
    _this.editShippingAddress.ShipToName = _this.addressFormModel.shipToName;
    _this.editShippingAddress.LineOne = _this.addressFormModel.addressLine1;
    _this.editShippingAddress.LineTwo = _this.addressFormModel.addressLine2;
    _this.editShippingAddress.City = _this.addressFormModel.city;
    _this.editShippingAddress.State = _this.addressFormModel.stateRegionProvince;
    _this.editShippingAddress.PostalCode = _this.addressFormModel.postalCode ? _this.addressFormModel.postalCode : null;
    _this.editShippingAddress.Id = undefined;
    if (addressFormModel.country !== _this.editShippingAddress.Country) {
      _this.editShippingAddress.Country = addressFormModel.country;
      _this.handleChangeFormCountry();
    }
  };
  this.handleChangeDropDownAddress = function () {
    _this.actions.setSelectedShippingAddress(_this.state.selectedShippingAddress);
    _this.editShippingAddress = _this.state.selectedShippingAddress;
    _this.updateStateField();
    _this.updateAddressFormModel();
  };
  this.updateAddressFormModel = function () {
    if (!_this.editShippingAddress) {
      return;
    }
    var selectedAddress = _this.editShippingAddress;
    _this.addressFormModel = Object.assign({}, selectedAddress, {
      addressLine1: selectedAddress.LineOne,
      addressLine2: selectedAddress.LineTwo,
      city: selectedAddress.City,
      country: selectedAddress.Country,
      postalCode: selectedAddress.PostalCode,
      shipToName: selectedAddress.ShipToName,
      stateRegionProvince: selectedAddress.State
    });
  };
  this.onSubmitChangeShippingAddressModal = function () {
    _this.actions.setUpdatedShippingAddress(_this.editShippingAddress);
    _this.changeShippingAddressForm.$setSubmitted(true);
    _this.showErrorSummary = true;
    if (_this.changeShippingAddressForm.$valid) {
      _this.updateSelectedShippingAddress()();
    }
  };
  this.onCloseModal = function () {
    _this.actions.setSelectedShippingAddress(_this.state.updatedShippingAddress);
    _this.closeChangeShippingAddressPopup()();
  };
  this.$onDestroy = function () {
    _this.disconnectRedux();
  };
}
export default {
  template: require('./change.shipping.address.popup.html'),
  bindings: {
    addressStatesOptions: '<',
    closeChangeShippingAddressPopup: '&',
    postalCode: '<',
    shippingAddressDropdownOptions: '<?',
    shippingAddress: '<?',
    updateSelectedShippingAddress: '&'
  },
  controller: ChangeShippingAddressPopupController
};